import { defineMessages } from 'react-intl';

export default defineMessages({
  flaggedComments: 'Flagged comments',
  flaggedAt: 'Flagged',
  resolve: 'Resolve',
  resolveLegacy: 'Resolve (rules)',
  resolvePii: 'Resolve (PII scan)',
});
